import { Controller } from "@hotwired/stimulus";
import firebase from "firebase/app";
import "firebase/auth";

export default class extends Controller {
  connect() {
    const firebaseConfig = {
      apiKey: "AIzaSyAoGLGYST59btTzE-I_uU_X7dsyPOKlyhs",
      authDomain: "saludtech-48e78.firebaseapp.com",
      databaseURL: "https://saludtech-48e78.firebaseio.com/",
      projectId: "saludtech-48e78",
      storageBucket: "saludtech-48e78.appspot.com",
      messagingSenderId: "123295551612",
      appId: "1:123295551612:web:73b2547001a0a1455e39f9",
      measurementId: "G-360LGEV1EY",
    };

    firebase.initializeApp(firebaseConfig);
  }

  handleGetToken(idToken, prevWindow) {
    const basePath = this.data.get("path");
    const formType = this.data.get("form-type");
    if (formType) {
      prevWindow.location.href = `${basePath}?t=${idToken}&form=${formType}`;
    } else {
      prevWindow.location.href = `${basePath}?t=${idToken}`;
    }
  }

  async onSignIn() {
    const provider = new firebase.auth.GoogleAuthProvider();

    await firebase.auth().signInWithPopup(provider);

    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => this.handleGetToken(idToken, window))
      .catch((error) => console.log(error));
  }
}
